import idb from '@/store/services/idb';
import { WsCalls } from '@/store/services/wsCalls';
import { sha512 } from 'js-sha512';

// initial state
const state = () => ({
  isu: 0,
  user: null,
  chave_pix: null,
  selectedAddress: {
    destiny_type: 0,
    id: 0
  },
  addresses: [],
  adjustAddresses: [],
  loadingUser: true,
  loadingAddresses: true
})

// getters
const getters = {
  getIsu: (state) => {
    return state.isu;
  },
  getUserInfo: (state) => {
    return state.user;
  },
  getChavePix: (state) => {
    return state.chave_pix;
  },
  getSelectedAddress: (state, getters, rootState) => {
    let ad = {
      destiny_type: state.selectedAddress.destiny_type
    };
    var temp = null;
    if(state.selectedAddress.destiny_type >= 1){
      temp = state.addresses.find(p => p.address_id == state.selectedAddress.id);
    } else {
      temp = rootState.main.storePickup.find(p => p.store_id == state.selectedAddress.id);
    }
    if(temp != null){
      ad = temp;
      ad.destiny_type = state.selectedAddress.destiny_type;
    }
    return ad;
  },
  getAlladdresses: (state) => {
    return state.addresses;
  },
  getAdjustAddresses: (state) => {
    return state.adjustAddresses;
  },
  getAddressById: (state) => (id) => {
    return state.addresses.find(address => address.address_id == id);
  },
}

// actions
const actions = {
  async userLogin ({ rootGetters, dispatch }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'userLogin', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100) {
          let reverse = sha512(parametros.password).split("").reduce((acc, char) => char + acc, "");
          localStorage.setItem("token", reverse);
          dispatch('updateIsu', response.data.return.isu).then(() => {
            dispatch('main/updateConfig', null, { root: true }).then(() => {
              dispatch('main/setVisit', {"preExisting": !parametros.signingup}, { root: true });
              resolve(true);
            });
          });
        } else {
          resolve(response.data.msg);
        }
      });
    })
  },
  async userResume ({ commit, rootGetters, dispatch }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userResume', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setUser', { name: response.data.return.client_name } );
          commit('setPix', { chave_pix: response.data.return.chave_pix } );
          if(response.data.return.destiny_type >= 1){
            commit('setAddresses', [ response.data.return.selected_destiny ] );
          } else {
            commit('main/setStorePickup', [ response.data.return.selected_destiny ], { root: true });
          }
          commit('setAdjustAddresses', response.data.return.addresses.filter(i => i.lat == 0) );
          commit('setAddress', { "destiny_type": response.data.return.destiny_type, "id": response.data.return.destiny_type >= 1 ? response.data.return.selected_destiny.address_id : response.data.return.selected_destiny.store_id });
          commit('setLoadingUser', false);
          resolve(true);
        } else {
          dispatch('logout');
          commit('setLoadingUser', false);
          resolve(response.data.msg);
        }
      });
    });
  },
  async userProfile ({ commit, rootGetters, dispatch }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userProfile', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setUser', response.data.return);
          resolve(true);
        } else {
          dispatch('logout');
          resolve(response.data.msg);
        }
      });
    });
  },
  async verifyDocument ({ rootGetters }, cpfcnpj) {
    var doc = String(cpfcnpj.replace('/', '').replace('-', '').replace(/\./g, ''));
    var desc = doc.length > 11 ? "CNPJ": "CPF";
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'verifyDocument', rootGetters['main/getConfig'], null, { 'cpf': doc }).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null && response.data.return.is_invalid == 1) {
          resolve("O " + desc + " " + cpfcnpj + " já está cadastrado!");
        } else {
          resolve("");
        }
      });
    });
  },
  async loadAddresses ({ commit, rootGetters }, details) {
    commit('setLoadingAddresses', true);
    commit('setAddresses', []);
    return new Promise((resolve) => {
      let endpoint = details == true ? "userAddressDetails" : "userAddress";
      WsCalls.callMethodWS('GET', endpoint, rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100) {
          commit('setAddresses', response.data.return);
          commit('setLoadingAddresses', false);
          resolve(true);
        } else {
          commit('setAddresses', []);
          commit('setLoadingAddresses', false);
          resolve(response.data.msg);
        }
      });
    });
  },
  async deliveryTimes ({ rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'deliveryTimes', rootGetters['main/getConfig'], parametros.id, { "is-express": parametros.express }).then(function (response) {
        let horarios = null;
        if(response.data.return != null){
          horarios = response.data.return.reduce((agrupado, objeto) => {
            const date = objeto.date;
            if (!agrupado[date]) {
              agrupado[date] = [];
            }
            agrupado[date].push(objeto);
            return agrupado;
          }, {});
          horarios = Object.entries(horarios).map(([date, times]) => ({ date, times }));
        }
        resolve(horarios);
      });
    });
  },
  async logout ({ dispatch, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('DELETE', 'userLogout', rootGetters['main/getConfig']);
      dispatch('updateIsu', 0).then(() => {
        dispatch('main/updateConfig', null, { root: true }).then(() => {
          localStorage.removeItem("token");
          dispatch('main/setVisit', {"regenerateHash": true}, { root: true });
          resolve(true);
        });
      });
    })
  },
  async changeAddress ({ commit, rootGetters }, parametros) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('PATCH', 'profileDelivery', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 200) {
          commit('setAddress', { "destiny_type": parametros.destiny_type, "id": parametros.destiny_id });
          resolve(true);
        } else {
          resolve(response.data.msg);
        }
      });
    });
  },
  async updateIsu ({ commit, dispatch, rootGetters }, isu) {
    return new Promise((resolve) => {
      commit('setIsu', isu);
      if(isu > 0){
        dispatch('userResume');
      } else {
        commit('setLoadingUser', false);
      }
      dispatch('main/getTabs', null, { root: true }).then(function () {
        dispatch('products/getLikes', null, { root: true }).then(async function () {
          let itens = await idb.getData('cart');
          itens = itens.filter(p => p.data.store == rootGetters['main/getConfig'].store);
          if(isu > 0){
            if(itens.length > 0){
              dispatch('cart/clearCartOffline', isu, { root: true }).then(function () {
                resolve(true);
              });
            } else {
              dispatch('cart/loadItensCart', isu, { root: true }).then(function () {
                resolve(true);
              });
            }
          } else {
            dispatch('cart/loadItensCartOffline', itens, { root: true }).then(function () {
              resolve(true);
            });
          }
        });
      });
    })
  },
  async registerUser({ dispatch, rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'userProfile', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 200) {
          dispatch('userLogin', { "login": parametros.cpf, "password": parametros.password, "signingup": true }).then(function (response) {
            resolve(response);
          });
        } else {
          resolve(response.data.msg);
        }
      });
    });
  },
  async updateUser({ commit, rootGetters }, user){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('PATCH', 'userProfile', rootGetters['main/getConfig'], user).then(function (response) {
        if (response.data.cod == 200) {
          commit('updateUser', user);
        }
        resolve(response.data);
      });
    });
  },
  async updatePassword({ rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'changePassword', rootGetters['main/getConfig'], parametros).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async deleteUser({ dispatch, rootGetters }){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('DELETE', 'account', rootGetters['main/getConfig'], null, { token: localStorage.getItem('token') }).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async registerAddress({ dispatch, rootGetters }, address){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'userAddress', rootGetters['main/getConfig'], address).then(function (response) {
        if (response.data.cod == 200) {
          dispatch('loadAddresses', true).then(function(){
            resolve(response.data);
          });
        } else {
          resolve(response.data);
        }
      });
    });
  },
  async updateAddress({ dispatch, rootGetters }, address){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('PATCH', 'userAddress', rootGetters['main/getConfig'], address).then(function (response) {
        if (response.data.cod == 200) {
          dispatch('loadAddresses', true).then(function(){
            resolve(response.data);
          });
        } else {
          resolve(response.data);
        }
      });
    });
  },
  async deleteAddress({ dispatch, rootGetters }, id){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('DELETE', 'userAddress', rootGetters['main/getConfig'], { address_id: id }).then(function (response) {
        if (response.data.cod == 300) {
          dispatch('userResume').then(function(){
            dispatch('loadAddresses', true).then(function(){
              resolve(response.data);
            });
          });
        } else {
          resolve(response.data);
        }
      });
    });
  },
  async passwordRecovery({ rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'passwordRecovery', rootGetters['main/getConfig'], parametros).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async addressZipCode({ rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'addressZipCode', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100) {
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    });
  },
  async geoLocationByAddress({ rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'geoLocationByAddress', rootGetters['main/getConfig'], parametros).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async addressByGeoLocation({ rootGetters }, headers){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'addressByGeoLocation', rootGetters['main/getConfig'], null, headers).then(function (response) {
        resolve(response.data);
      });
    });
  },
}

// mutations
const mutations = {
  setIsu (state, isu) {
    state.isu = isu;
  },
  setUser (state, user) {
    state.user = user;
  },
  setPix (state, chave_pix) {
    state.chave_pix = chave_pix;
  },
  updateUser (state, user) {
    state.user.email = user.email;
    state.user.cell = user.cell;
    state.user.gender = user.gender;
  },
  setAddress (state, { destiny_type, id }) {
    state.selectedAddress.destiny_type = destiny_type;
    state.selectedAddress.id = id;
  },
  setAddresses (state, addresses) {
    // if(addresses.length > 0){
    //   if(addresses[0].area != null){
    //     addresses[0].area.express = {
    //       shipping: 20,
    //       estimated_time: 60,
    //       limit_quantity: 5,
    //       is_able: 1,
    //       first_window: {		
    //         "date": "2024-02-02",
    //         "start": "14:00:00",
    //         "end": "18:00:00"		
    //       }
    //     }
    //   }
    // }
    state.addresses = addresses;
  },
  addAddress (state, addresses) {
    state.addresses = addresses;
  },
  setLoadingUser (state, status) {
    state.loadingUser = status;
  },
  setLoadingAddresses (state, status) {
    state.loadingAddresses = status;
  },
  setAdjustAddresses (state, adjustAddresses) {
    state.adjustAddresses = adjustAddresses;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}